import GalleryGridItem from './GalleryGridItem';

export default GalleryGridItem;
